<template>
  <div class="location-item">
    <div v-if="namedLocation"
         class="address">
      {{ namedLocation.name }}
    </div>

    <div v-else
         class="address">
      {{ location.address }}
    </div>

    <div v-if="datesEqual"
         class="item-datetime">
      <span v-if="head" class="status">{{ $t("locationStatus.since") }}</span>
      <span v-if="timeEqual" class="time">{{ getStartTime }}</span>
      <span v-else class="time">{{ `${getStartTime} - ${getEndTime}` }}</span>
      <span class="date"> {{ getStartDate }}</span>
    </div>

    <div v-else
         class="item-datetime">
      <div class="start-time">
        <span v-if="head" class="status">{{ $t("locationStatus.since") }}</span>
        <span class="time">{{ getStartTime }}</span>
        <span class="date"> {{ getStartDate }}</span>
      </div>

      <div v-if="location.end_time"
          class="end-time">
        <span class="time">to {{ getEndTime }}</span>
        <span class="date"> {{ getEndDate }}</span>
      </div>
    </div>

    <div class="dropdown-option-arrow"
         @click.stop="openLocationConfigureScreen"></div>
  </div>
</template>

<script>
  import { localEventTime, localEventDate } from '@/services/localTime'

  export default {
    props: {
      location: {
        type: Object,
        required: true
      },

      childId: {
        type: String,
        required: true
      },

      head: {
        type: Boolean,
        required: true
      }
    },

    methods: {
      openLocationConfigureScreen() {
        if (this.$mq === 'mobile') {
          this.$router.push({
            name: 'configure-location',
            params: {
              mode: this.location.named_location_id ? 'update' : 'create',
              locationId: this.location.named_location_id,
              locationFromHistory: this.location
            }
          })

          return
        }

        this.showModal('geofence-configure', {
          mode: this.location.named_location_id ? 'update' : 'create',
          id: this.location.named_location_id,
          locationFromHistory: this.location
        })
      }
    },

    computed: {
      getStartTime() {
        return localEventTime(this.location.track_date)
      },

      getStartDate() {
        return localEventDate(this.location.track_date)
      },

      getEndTime() {
        if (!this.location.end_time) {
          return null
        } else {
          let time = localEventTime(this.location.end_time)

          return time
        }
      },

      getEndDate() {
        if (!this.location.end_time) {
          return null
        } else {
          let time = localEventDate(this.location.end_time)

          return time
        }
      },

      datesEqual() {
        return _.isEqual(this.getStartDate, this.getEndDate)
      },

      timeEqual() {
        return _.isEqual(this.getStartTime, this.getEndTime)
      },

      child() {
        return this.getChildById(this.childId)
      },

      namedLocation() {
        return this.getNamedLocationById(this.location.named_location_id)
      },


      ...mapGetters('children', {
        getChildById: 'getById'
      }),

      ...mapGetters('geofence', {
        getNamedLocationById: 'getNamedLocationById'
      })
    }
  }
</script>

<style lang="scss" scoped>
  .location-item {
    width: 100%;
    padding: 0 16px 0 16px;

    display: flex;
    justify-content: space-between;
    align-items: center;

    .address {
      color: #3e3a3b;
      opacity: .7;
      width: 180px;
      overflow: hidden;
      margin: 14px 0 14px 0;
    }

    .item-datetime {
      display: flex;
      flex: 1;
      flex-direction: column;
      align-items: flex-end;
      margin-right: 10px;
    }

    .status {
      margin-right: 5px;
      font-weight: bold;
      color: map-get($colors, primary);
    }

    .time {
      color: map-get($colors, primary);
    }

    .date {
      color: #999999;
    }

    .dropdown-option-arrow {
      width: 15px;
      height: 15px;
      border-bottom: 1px solid #b9b9b9;
      border-right: 1px solid #c2b4b4;
      transform: rotate(-45deg);
    }
  }
</style>
